import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { RouterModule } from "@angular/router";
import { FlexLayoutModule } from "@angular/flex-layout";
import { HttpClientModule } from "@angular/common/http";

import "hammerjs";

import { MaterialModule } from "./material.module";
import { AppComponent } from "./app.component";
import { DownloadService } from "./download.service";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { DownloadComponent } from "./download/download.component";
import { TRANSLATION_PROVIDERS, TranslatePipe, TranslateService } from "./translate";
import { ManifestType } from "./download/models";
import { RedirectGuard } from "./redirect-guard";

// Define the routes
// tslint:disable:max-line-length
const STANDARD_DOCUMENTATION_URL = "https://impulsepoint.atlassian.net/wiki/spaces/CK/pages/213483564/VM+Deployment+Guide#VMDeploymentGuide-SystemConfiguration";
// tslint:enable:max-line-length
const TACACS_DOCUMENTATION_URL = "https://impulsepoint.atlassian.net/servicedesk/customer/portal/1/article/213385251";
const DOWNLOAD_DATA: DownloadComponent.Data = {
	documentationUrl: STANDARD_DOCUMENTATION_URL,
	manifestType: ManifestType.STANDARD
};
const SMB_DATA: DownloadComponent.Data = {
	documentationUrl: STANDARD_DOCUMENTATION_URL,
	manifestType: ManifestType.SMALL
};
const TACACS_DATA: DownloadComponent.Data = {
	documentationUrl: TACACS_DOCUMENTATION_URL,
	manifestType: ManifestType.TACACS
};
export const ROUTES = [
	{
		path: "",
		redirectTo: "download",
		pathMatch: "full"
	},
	{
		path: "download",
		component: RedirectGuard,
		canActivate: [RedirectGuard],
		data: {
			externalUrl: "https://portal.opswat.com/products/metaaccess-nac"
		}
	},
	{
		path: "smb",
		redirectTo: "download",
		pathMatch: "full"
	},
	{
		path: "tacacs",
		component: DownloadComponent,
		data: TACACS_DATA
	}
];

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		DownloadComponent,
		TranslatePipe
	],
	imports: [
		BrowserModule,
		ReactiveFormsModule,
		HttpModule,
		HttpClientModule,
		RouterModule.forRoot(ROUTES),
		MaterialModule,
		FlexLayoutModule
	],
	providers: [
		DownloadService,
		TRANSLATION_PROVIDERS,
		TranslateService,
		RedirectGuard
	],
	bootstrap: [
		AppComponent
	]
})
export class AppModule { }
